var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTyping)?_c('div',{staticClass:"chat-typing-indicator"},[_c('span',{staticClass:"typing-text"},[_vm._v(_vm._s(_vm.typingText))]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"typing-dots"},[_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"})])
}]

export { render, staticRenderFns }